import type { ComponentPropsWithRef, ReactNode } from "react";
import { forwardRef } from "react";
import { Column, Row, Section } from "@react-email/components";
import type { StyleValue } from "@circle-react-shared/BuilderUI/StyleValue.types";
import { useGoober } from "../../../Design/GooberContext";
import { mobileMediaQuery } from "../../../Design/mediaQuery";
import { useTopBlockStyles } from "../../../Design/useTopBlockStyles";
import { SectionContainer } from "../../../Utils/SectionContainer";
import { defaultStyles } from "./defaultStyles";

const columnMediaQuery = `
  display: block;
  width: 100% !important;
  padding-right: 0 !important;
  padding-left: 0 !important;
`;

interface ImageGalleryBlock2Props extends ComponentPropsWithRef<"table"> {
  headerContent: ReactNode;
  imageNode1?: ReactNode;
  imageNode2?: ReactNode;
  imageNode3?: ReactNode;
  imageNode4?: ReactNode;
  styles?: Record<string, StyleValue>;
}

export const ImageGalleryBlock2 = forwardRef<
  HTMLTableElement,
  ImageGalleryBlock2Props
>(
  (
    {
      headerContent,
      imageNode1,
      imageNode2,
      imageNode3,
      imageNode4,
      styles = {},
      ...rest
    },
    ref,
  ) => {
    const { css } = useGoober();

    const { backgroundStyles, paddingStyles, marginStyles } = useTopBlockStyles(
      {
        styles,
        defaultStyles,
      },
    );

    return (
      <SectionContainer cssProperties={marginStyles}>
        <Section
          ref={ref}
          style={{
            ...paddingStyles,
            ...backgroundStyles,
          }}
          {...rest}
        >
          <Row>
            <Column>{headerContent}</Column>
          </Row>
          <Row cellPadding={0} style={{ paddingBottom: 0 }}>
            <Column
              style={{ width: "50%" }}
              className={css`
                ${mobileMediaQuery} {
                  ${columnMediaQuery} margin-bottom: 16px;
                }
              `}
            >
              {imageNode1}
            </Column>
            <Column
              style={{ width: "50%" }}
              className={css`
                ${mobileMediaQuery} {
                  ${columnMediaQuery}
                }
              `}
            >
              {imageNode2}
            </Column>
          </Row>
          <Row cellPadding={0}>
            <Column
              style={{ width: "50%" }}
              className={css`
                ${mobileMediaQuery} {
                  ${columnMediaQuery} margin-bottom: 16px;
                }
              `}
            >
              {imageNode3}
            </Column>
            <Column
              style={{ width: "50%" }}
              className={css`
                ${mobileMediaQuery} {
                  ${columnMediaQuery}
                }
              `}
            >
              {imageNode4}
            </Column>
          </Row>
        </Section>
      </SectionContainer>
    );
  },
);

ImageGalleryBlock2.displayName = "ImageGalleryBlock2";
